export function filterFloat(value) {
  if (value.endsWith(".")) value += "0";
  if (value.startsWith(".")) value = "0" + value;

  if (/^(-|\+)?([0-9]+(\.[0-9]+)?)$/.test(value)) return parseFloat(value);
  return NaN;
}
